import React, {useState} from 'react';
import { Container, Tab, Row, Col, Nav, Form, Button } from 'react-bootstrap';
import { Stage, Layer, Image , Text, Transformer, Group } from 'react-konva';
import useImage from 'use-image';
import ImageUploader from 'react-images-upload';
import FontPicker from "font-picker-react";
import "./tshirt.scss";
import { Link } from 'react-router-dom';
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";


const TextRect = ({text,font,color,fontFamily,alignment,shapeProps,isSelected, onSelect, onChange,onDragEndM,onDragStartM,onDragEndMove,idParam  }) => {  
  	const shapeRef = React.useRef();
    return (
        <React.Fragment>
			<Text
				text={text}
				fill={color}
				onDragStart={(e) => {
					onDragStartM(true)
				}}
				fontSize={font}
				fontFamily={fontFamily}
				align={alignment}
				shadowOffset={{x:1,y:1}}
				onClick={() => onSelect(idParam)}
				onTap={() => onSelect(idParam)}
				ref={shapeRef}
				{...shapeProps}
				draggable
				onDragEnd={(e) => {
					onDragEndM(false)
					onChange({
						...shapeProps,
						x: e.target.x(),
						y: e.target.y(),
					});
				}}
			/>		
        </React.Fragment>
    );
}
	
const TextRectB = ({text,font,color,fontFamily,alignment,shapeProps,isSelected, onSelect, onChange,onDragEndM,onDragStartM,onDragEndMove,idParam}) => {  
	const shapeRef = React.useRef();
	return (
		<React.Fragment>
			<Text
				text={text}
				fill={color}
				onDragStart={(e) => {
					onDragStartM(true)
				}}
				fontSize={font}
				fontFamily={fontFamily}
				align={alignment}
				shadowOffset={{x:1,y:1}}
				onClick={() => onSelect(idParam)}
				onTap={() => onSelect(idParam)}
				ref={shapeRef}
				{...shapeProps}
				draggable
				onDragEnd={(e) => {
					onDragEndM(false)
					onChange({
						...shapeProps,
						x: e.target.x(),
						y: e.target.y(),
					});
				}}
				
			/>		
		</React.Fragment>
	);
}

const ImageBg = ({selectedImg,shapeProps,isSelected, onSelect, onChange,onDragEndM,onDragStartM,onDragEndMove,idParam }) => {  
	const [image] = useImage(selectedImg,'Anonymous');
	const [isDragging,setIsDragging] = useState(false);
	const [imageWidth,setImageWidth] = useState(0);
	const [imageHeight,setImageHeight] = useState(0);
	const [imageX,setImageX] = useState(150);
	const [imageY,setImageY] = useState(150);
	const shapeRef = React.useRef();
	const trRef = React.useRef();
	React.useEffect(() => {
		setImageWidth(shapeProps && shapeProps.width?shapeProps.width:(image?(image.width > 150?150:image.width):0))
		setImageHeight(shapeProps && shapeProps.height?shapeProps.height:(image?(image.height > 150?(image.height * (150/image.width)):image.height):0))
		setImageX(shapeProps && shapeProps.x?((shapeProps.x > 250 || shapeProps.x < 100)?150:shapeProps.x):200)
		setImageY(shapeProps && shapeProps.y?((shapeProps.y > 550 || shapeProps.y < -50)?200:shapeProps.y):200) 
	if (isSelected === 'img') {
		// we need to attach transformer manually
		trRef.current.nodes([shapeRef.current]);
		trRef.current.getLayer().batchDraw();
	}
	}, [isSelected,image,imageWidth,setImageWidth,imageHeight,setImageHeight,shapeProps]);
    return (
      	<React.Fragment>
			<Image
				image={image}
				fill={isDragging ? 'green' : ''}
				onDragStart={(e) => {
				setIsDragging(true)
				onDragStartM(true)
				}}
				onClick={() => onSelect(idParam)}
						onTap={() => onSelect(idParam)}
						isSelected={'img'}
				ref={shapeRef}
				x={imageX}
				y={imageY}
				{...shapeProps}
				draggable
				width={imageWidth}
				height={imageHeight}
				onDragEnd={(e) => {
				onDragEndM(false)
				setIsDragging(false)
				onChange({
					...shapeProps,
					width:e.target.width(),
					height:e.target.height(),
					x: e.target.x(),
					y: e.target.y(),
				});
				}}
				onTransformEnd={(e) => {
					const node = shapeRef.current;
					const scaleX = node.scaleX();
					const scaleY = node.scaleY();

					// we will reset it back
					node.scaleX(1);
					node.scaleY(1);
					onChange({
						...shapeProps,		
						x: node.x(),
						y: node.y(),
						// set minimal value
						width: 	 Math.max(5, node.width() * scaleX),
						height:  Math.max(node.height() * scaleY),
					});
					onDragEndMove(false,shapeProps)
				}}
			/>
				
			{isSelected === 'img' && (
				<Transformer
					ref={trRef}
					boundBoxFunc={(oldBox, newBox) => {
						// limit resize
						if (newBox.width < 5 || newBox.height < 5) {
							return oldBox;
						}
						return newBox;
					}}
				/>
			)}
        </React.Fragment>
    );
}

const ImageBgB = ({selectedImg,shapeProps,isSelected, onSelect, onChange,onDragEndM,onDragStartM,onDragEndMove,idParam }) => {  
	const [image] = useImage(selectedImg,'Anonymous');
	const [isDragging,setIsDragging] = useState(false);
	const [imageWidth,setImageWidth] = useState(0);
	const [imageHeight,setImageHeight] = useState(0);
	const [imageX,setImageX] = useState(150);
	const [imageY,setImageY] = useState(150);
	const shapeRef = React.useRef();
	const trRef = React.useRef();
	React.useEffect(() => {
		setImageWidth(shapeProps && shapeProps.width?shapeProps.width:(image?(image.width > 150?150:image.width):0))
		setImageHeight(shapeProps && shapeProps.height?shapeProps.height:(image?(image.height > 150?(image.height * (150/image.width)):image.height):0))
		setImageX(shapeProps && shapeProps.x?((shapeProps.x > 250 || shapeProps.x < 50)?150:shapeProps.x):200)
		setImageY(shapeProps && shapeProps.y?((shapeProps.y > 550 || shapeProps.y < -50)?200:shapeProps.y):200)
		if (isSelected === 'imgB') {
			// we need to attach transformer manually
			trRef.current.nodes([shapeRef.current]);
			trRef.current.getLayer().batchDraw();
		}
	}, [isSelected,image,imageWidth,setImageWidth,imageHeight,setImageHeight,shapeProps]);
	return (
		<React.Fragment>
			<Image
				image={image}
				fill={isDragging ? 'green' : ''}
				onDragStart={(e) => {
					setIsDragging(true)
					onDragStartM(true)
				}}
				onClick={() => onSelect(idParam)}
				onTap={() => onSelect(idParam)}			
				ref={shapeRef}
				{...shapeProps}
				x={imageX}
				y={imageY}
				draggable
				width={imageWidth}
				height={imageHeight}
				onDragEnd={(e) => {
					onDragEndM(false)
					setIsDragging(false)
					onChange({
						...shapeProps,
						width:e.target.width(),
						height:e.target.height(),
						x: e.target.x(),
						y: e.target.y(),
					});
				}}
				onTransformEnd={(e) => {
					// transformer is changing scale of the node
					// and NOT its width or height
					// but in the store we have only width and height
					// to match the data better we will reset scale on transform end
					const node = shapeRef.current;
					const scaleX = node.scaleX();
					const scaleY = node.scaleY();

					// we will reset it back
					node.scaleX(1);
					node.scaleY(1);
					onChange({
						...shapeProps,
						x: node.x(),
						y: node.y(),
						// set minimal value
						width: Math.max(5, node.width() * scaleX),
						height: Math.max(node.height() * scaleY),
					});
					onDragEndMove(false,shapeProps)
				}}
			/>
			
			{
				isSelected === 'imgB' && (
					<Transformer
						ref={trRef}
						boundBoxFunc={(oldBox, newBox) => {
							// limit resize
							if (newBox.width < 5 || newBox.height < 5) {
								return oldBox;
							}
							return newBox;
						}}
					/>
				)
			}
		</React.Fragment>
	);
}

const FixShape = ({bgImage,width,height}) => {
	const [image] = useImage(bgImage,'Anonymous');	
	const shapeRef = React.useRef();
	return (
		<React.Fragment>
			<Image
				image={image}
				ref={shapeRef}
				width={width}     
				height={height}      
			/>
		</React.Fragment>
	);
}

// make a portal implementation
const Portal = ({ selector, enabled, children }) => {
  // "selector" is a string to find another container to insert all internals
  // if can be like ".top-layer" or "#overlay-group"
  const outer = React.useRef(null);
  const inner = React.useRef(null);

  	React.useEffect(() => {
		const stage = outer.current.getStage();
		const newContainer = stage.findOne(selector);
		if (enabled && newContainer) {
			inner.current.moveTo(newContainer);
		} else {
			inner.current.moveTo(outer.current);
		}
		// manually redraw layers
		outer.current.getLayer().batchDraw();
		if (newContainer) {
			newContainer.getLayer().batchDraw();
		}
  	}, [selector, enabled]);

	// for smooth movement we will have to use two group
	// outer - is main container
	// inner - that we will move into another container
  	return (
		<Group name="_outer_portal" ref={outer}>
		<Group name="_inner_portal" ref={inner}>
			{children}
		</Group>
		</Group>
  	);
};
const initialImage = {
    x: 200,
    y: 150,
    id: 'img',
};

const initialText = {
    x: 200,
    y: 200,
    id: 'txt',
};
	
const initialImageB = {
    x: 200,
    y: 150,
    id: 'imgB',
};
const initialTextB = {
    x: 200,
    y: 200,
    id: 'txtB',
};



const Tshirt = (pData ) => {
	

	const resizeImage = (base64Str, maxWidth = 50, maxHeight = 50) => {
		
		return new Promise((resolve) => {
			let imgD = new window.Image()
			imgD.src = base64Str
		  
			imgD.onload = () => {
				let canvas = document.createElement('canvas')
				const MAX_WIDTH = maxWidth
				const MAX_HEIGHT = maxHeight
				let width = imgD.width
				let height = imgD.height
		
				if (width > height) {
				if (width > MAX_WIDTH) {
					height *= MAX_WIDTH / width
					width = MAX_WIDTH
				}
				} else {
				if (height > MAX_HEIGHT) {
					width *= MAX_HEIGHT / height
					height = MAX_HEIGHT
				}
				}
				canvas.width = width
				canvas.height = height
				let ctx = canvas.getContext('2d')
				ctx.drawImage(imgD, 0, 0, width, height)
				resolve(canvas.toDataURL())
			}
		})
	}

	const stageRef = React.useRef(null);
	
	const [images, setImages] = React.useState(initialImage);
	const [texts, setTexts] = React.useState(initialText);
	// const [selectedImg, setSelectedImg] = React.useState(pData.imageUrlData);
	const [textData, setTextData] = React.useState(pData.tData.text[0]);
	const [selectedId, selectShape] = React.useState('img');  
	const [selectedTextId, selectText] = React.useState('txt');
	const [isDragging, setDragging] = React.useState(false);
	const [fontSize, setFontSize] = React.useState(pData.tData.fontSize[0]);
	const [fontFamily, setFontFamily] = React.useState(pData.tData.fontFamily[0]);
	const [color, setColor] = React.useState(pData.tData.fontColor[0]);
	const [alignment, alignText] = React.useState('left');
	const [textNode,settextNode] = React.useState(pData.tData.txtNode[0]);
	const [imgNode,settimgNode] = React.useState(pData.iData.imgNode[0]);	
	const [imagesB, setImagesB] = React.useState(initialImageB);
	const [textsB, setTextsB] = React.useState(initialTextB);
	// const [selectedImgB, setSelectedImgB] = React.useState(pData.imageUrlDataB);
	const [textDataB, setTextDataB] = React.useState(pData.tData.text[1]);
  	const [fontSizeB, setFontSizeB] = React.useState(pData.tData.fontSize[1]);
  	const [fontFamilyB, setFontFamilyB] = React.useState(pData.tData.fontFamily[1]);
	const [colorB, setColorB] = React.useState(pData.tData.fontColor[1]);
	const [alignmentB, alignTextB] = React.useState('left');
	const [textNodeB,settextNodeB] = React.useState(pData.tData.txtNode[1]);
	const [imgNodeB,settimgNodeB] = React.useState(pData.iData.imgNode[1]);

	let c = pData.ColorsData.find(item=> {return item.name === (pData.pData && pData.pData[0].color)})
	const [bgColor, setBgColor] = React.useState(c?c.hex_code:'');
	const [bgColorF, setBgColorF] = React.useState(pData.pData && pData.pData[0].color);
	const [bgSize, setBgSize] = React.useState(pData.pData && pData.pData[0].size);
	const [bgSleeve, setBgSleeve] = React.useState(pData.pData && pData.pData[0].sleeve)
	const [bgImage, setBgImg] = React.useState(pData.pData &&  pData.pData[0].photo.front)
	const [showBoth, BothShow] = React.useState(0);
	const [tSide,settSide] = React.useState(0);
	const [dwidth,setWidth] = React.useState(500);
	const [dheight,setDheight] = React.useState(500)
	const[videoPopUp, setVideoPopUp] = React.useState(false)
	
	let width =0; let height = 0;
	React.useEffect(() => {
		
		setBgSize(pData.pData && pData.pData[0].size)
		
		// setBgImg(pData.pData && pData.pData[0].photo.front)
		setBgSleeve(pData.pData && pData.pData[0].sleeve)
		if(tSide === 0){
			setBgImg(pData.pData[0].photo.front)
		}else{
			setBgImg(pData.pData[0].photo.back)
		}
	}, [pData.pData,bgImage,setBgImg,setBgSize,bgSize,setBgSleeve,bgSleeve,tSide, width, height])

	React.useEffect(() => {
		BothShow(parseInt(pData.paintFront))
		if(pData.paintFront === '2'){
			setBgImg(pData.pData &&  pData.pData[0].photo.back)
			settSide(1)
		}else if(pData.paintFront === '0'){
			setBgImg(pData.pData &&  pData.pData[0].photo.front)
			settSide(0)
		}
		if(document.getElementById('container').offsetWidth < 600){
			setWidth(300)
			setDheight(290)
			
			// setImages(pData.iData.imgNode[0] !==null ? pData.iData.imgNode[0] : {x: 100, y:50, id: 'img'})
			// setImagesB(pData.iData.imgNode[1] !== null ? pData.iData.imgNode[1]: {x: 100, y:50, id: 'imgB'})
			setTexts({
				x: 110,
				y: 70,
				id: 'txt',
			})
			setTextsB({
				x: 110,
				y: 70,
				id: 'txt',
			})
			
		}
		
		
	},[pData.paintFront,BothShow,pData.iData, showBoth, pData.pData,dwidth,dheight,setWidth,setDheight])


	const changeVar = (e) => {
		onEveryChange();
		for(let item of pData.ColorsData){
			if(item.name === e.target.value){
				setBgColor(item.hex_code)				
				setBgColorF(item.name)
			}
		}
		pData.variableApi({color:e.target.value,size:bgSize,sleeve:bgSleeve,pId:pData.pData[0].product_id})
	} 

	const changeSleeve = (e) => {
		onEveryChange();
		setBgSleeve(e.target.value)
		pData.variableApi({color:bgColorF,size:bgSize,sleeve:e.target.value,pId:pData.pData[0].product_id})
	} 

	const changeSize = (e) => {
		onEveryChange();
		setBgSize(e.target.value)
		pData.variableApi({color:bgColorF,size:e.target.value,sleeve:bgSleeve,pId:pData.pData[0].product_id})
	} 

	
	const addToCard = async () =>{
		selectShape('')
		setDragging(false)
		pData.setLoader(true);
		let thumbobjFront = '';
		let thumbobjBack ='';
		if(showBoth === 1 || showBoth === 0){
			if(tSide === 1){
				setBgImg(pData.pData[0].photo.front);
				settSide(0);
			}
			setTimeout( async ()=>{
				let img = stageRef.current.toDataURL({ pixelRatio: 3 }) ;
				let resize = await resizeImage(img,500,500).then(result => result);			
				thumbobjFront = resize;	
			},2000)
		}


		if(showBoth === 1 || showBoth === 2){
			setTimeout( async ()=>{
				setBgImg(pData.pData[0].photo.back);
				settSide(1);
				setTimeout( async ()=>{
					let img = stageRef.current.toDataURL({ pixelRatio: 3 }) ;
					let resize = await resizeImage(img,500,500).then(result => result);
					thumbobjBack = resize;
				},1000)
			},4000)
		}
		
		setTimeout(()=>{
			pData.pData[0]['thumbnailFront'] = thumbobjFront;
			pData.pData[0]['thumbnailBack'] = thumbobjBack;
			pData.pData[0]['print_type'] = pData.paintFront;
			pData.addToCart(pData.pData[0])
		},6000)
	}

	const onEveryChange = () => {
		let imgobj = {
			imgNode:[imgNode,imgNodeB],
			img:[pData.imageUrlData,pData.imageUrlDataB],
		}
		let txtobj = {
			text:[textData,textDataB],
			txtNode:[textNode,textNodeB],
			textP:[texts,textsB],
			fontFamily:[fontFamily,fontFamilyB],
			fontSize:[fontSize,fontSizeB],
			fontColor:[color,colorB],
			alignment:[alignment,alignmentB],

		}
		pData.objSet(txtobj,imgobj)
	}


  	const checkDeselect = (e) => {    
		 setDragging(true) 
  	};

	const clickVideo =()=>{
		setVideoPopUp(true)
	}

	const onCloseModal=()=>{
		setVideoPopUp(false)
	}

	const closeIcon = (

		<i className="fa fa-times closeIconbgVideo" aria-hidden="true"></i>
	);

  	return (
		<Container id="container">
			<Row>
				<Col sm={6} className="canvasContainer customize-shirt">
					{
						showBoth === 1 &&
						<Button className="bg-bd-color" variant="primary" onClick={() => {setBgImg(pData.pData[0].photo.back);settSide(1)}}>Back</Button>
					}
					{
						showBoth === 1 &&
						<Button className="bg-bd-color" variant="primary" onClick={() => {setBgImg(pData.pData[0].photo.front);settSide(0)}}>Front</Button>
					}
					<div className="text-center"  style={{background:bgColor}}>					
						<Stage
							onMouseDown={checkDeselect}
							onTouchStart={checkDeselect}					
							ref={stageRef}
							width={dwidth} height={dheight} >
							<Layer>					
								<Portal selector=".top-layer" enabled={isDragging}>
									{pData.imageUrlData !== '' && bgImage === pData.pData[0].photo.front && 
										<ImageBg
											selectedImg={pData.imageUrlData}
											shapeProps={images}
											isSelected={selectedId}
											onSelect={() => {
												selectShape('img');
												onEveryChange()
											}}
											onChange={(newAttrs) => {
												const rects = newAttrs;
												setImages(rects);
												
												settimgNode(rects)
												onEveryChange()
											}}
											onDragStartM={(e)=>{
													setDragging(e)
													onEveryChange()
													// selectShape(null);
												}
											}
											onDragEndM={(e)=>{
													setDragging(e)
													onEveryChange()
													// selectShape(null);
												}
											} 
											onDragEndMove={(e,node)=>{
												setDragging(false)
												selectShape(null);
												settimgNode(node)
												onEveryChange()
												}
											}
											// idParam={idParamImg}
										/>  
									}     
									{
										textData !== '' &&  bgImage === pData.pData[0].photo.front &&       
										<TextRect 
											text={textData}
											font={fontSize}
											color={color}
											fontFamily={fontFamily}
											alignment={alignment}
											shapeProps={texts}
											isSelected={selectedTextId}
											onSelect={(e) => {
												selectText(e);
											}}
											onChange={(newAttrs) => {
												const rects = newAttrs;
												setTexts(rects);
											}}
											onDragStartM={(e)=>{
													setDragging(e)
													
												selectShape(null);
												// selectShapeB(null);
												// selectTextB(null);
												}
											}
											onDragEndM={(e)=>{
													setDragging(e)
													// selectText(null);
												}
											}
											onDragEndMove={(e,node)=>{
												setDragging(e)
												settextNode(node)
												}
											}
											// idParam={idParamTxt}
										/>
									}

									{
										pData.imageUrlDataB !== '' && bgImage === pData.pData[0].photo.back &&  
										<ImageBgB
											selectedImg={pData.imageUrlDataB}
											shapeProps={imagesB}
											isSelected={selectedId}
											onSelect={() => {
												selectShape('imgB');
												onEveryChange();
											}}
											onChange={(newAttrs) => {
												const rects = newAttrs;
												setImagesB(rects);
												
												settimgNodeB(rects)
												onEveryChange();
											}}
											onDragStartM={(e)=>{
													setDragging(e)
													onEveryChange();
												}
											}
											onDragEndM={(e)=>{
													setDragging(e)
													// selectShapeB(null);
													onEveryChange();
													
												}
											} 
											onDragEndMove={(e,node)=>{
												setDragging(false)
												selectShape(null);
												settimgNodeB(node)
												onEveryChange();
												}
											}											
											// idParam={idParamImgB}
										/>  
									}     
									{
										textDataB !== '' &&  bgImage === pData.pData[0].photo.back &&       
										<TextRectB 
											text={textDataB}
											font={fontSizeB}
											color={colorB}
											fontFamily={fontFamilyB}
											alignment={alignmentB}
											shapeProps={textsB}
											isSelected={'txtB'}
											onSelect={() => {
												// selectTextB(texts.id);
												onEveryChange();
											}}
											onChange={(newAttrs) => {
												const rects = newAttrs;
												setTextsB(rects);
												onEveryChange();
											}}
											onDragStartM={(e)=>{
													setDragging(e)
													
												selectText(null);
												// selectShapeB(null);
												selectShape(null);
												onEveryChange();
												}
											}
											onDragEndM={(e)=>{
													setDragging(e)
													// selectTextB(null);
													onEveryChange();
												}
											} 
											onDragEndMove={(e,node)=>{
												setDragging(e)
												settextNodeB(node)
												onEveryChange();
												}
											} 
											
											// idParam={idParamTxtB}
										/>
									}
								</Portal>
								<FixShape  bgImage={bgImage} width={dwidth} height={dheight} />
							</Layer> 
							<Layer name="top-layer" />
						</Stage>
					</div>
				</Col>
		
				<Col sm={6}>
					<Tab.Container id="left-tabs-example" defaultActiveKey="first">
						<Row>
							<Col sm={12}>
								<div className="product-single-details">
									<div className="display-tips">
										<h1 className="product-title font-capital font-rsp">{pData.pData[0].name}</h1>
										{/* End .product-container */}
										<Link className="tips-a" to={'/tips-on-designing-tees'} target='_blank'>Tips On Designing</Link>
										<span  className="tips-a videoClick" onClick={()=>clickVideo()}>How To Designing</span>
									</div>
									<Modal open={videoPopUp} onClose={onCloseModal} closeIcon={closeIcon}>
										<iframe className="ifremaWidth-hight" title="tshirt" src="https://www.youtube.com/embed/8ubFKwWRo0c" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>                              
									</Modal> 
									<div className="price-box">
										<span className="old-price">
											<i className="fa fa-rupee-sign " aria-hidden="true"></i>
											{pData.pData[0].price}.00
										</span>
										<span className="product-price color-price">
											<i className="fa fa-rupee-sign" aria-hidden="true"></i>
											{showBoth === 1? parseInt(pData.pData[0].sale_price) + 50 : pData.pData[0].sale_price}.00
										</span>
									</div>
									{/* End .price-box */}
									<div>
										<Col>
											<h4 className="widget-title">
												Selected Colors
											</h4>
											<table  className="variations table-width" cellSpacing="0">
												<tbody>
													<tr>
														<td className="label ">
															<label htmlFor="pa_color" className="col-md-6">Print On</label>
														</td>
														<td className="value">
															<select className="col-md-9 variationsSelect" name="attribute_pa_color" data-attribute_name="attribute_pa_color" data-show_option_none="yes" 
															onChange={(e) => pData.paintOn(e.target.value)} 
															// value={bgColorF}
															>
																<option value="0"  className="attached enabled">Front Only</option>
																
																<option value="2"  className="attached enabled">Back Only</option>
																
																<option value="1"  className="attached enabled">Front & Back Both</option>			
															</select>
															{
																showBoth === 1 && <div className="error-message pt-2">*For Front & Back 50.00 Rupees Extra</div>
															}
														</td>
													</tr>
													{
														pData.pData && pData.pData[0].colour_status === "True" &&
														<tr>
															<td className="label ">
																<label htmlFor="pa_color" className="col-md-3">
																	Color
																</label>
															</td>
															<td className="value">
																<select className="col-md-9 variationsSelect" name="attribute_pa_color" data-attribute_name="attribute_pa_color" data-show_option_none="yes" onChange={(e) =>  changeVar(e)} value={bgColorF}>
																	{ 
																		pData.ColorsData.map((item,i)=>(
																		<option value={item.name} id={item.hex_code}className="attached enabled" key={i}>{item.name}</option>
																		))
																	}
																</select>
															</td>
														</tr>
													}

													{
														pData.pData && pData.pData[0].size_status === "True" &&
														<tr>
															<td className="label ">
																<label htmlFor="pa_color" className="col-md-3">Size</label>
															</td>
															<td className="value">
																<select className="col-md-9 variationsSelect" name="attribute_pa_color" data-attribute_name="attribute_pa_color" data-show_option_none="yes" onChange={(e) => changeSize(e)} value={bgSize}>
																	{ 
																		pData.SizeData.map((item,i)=>(
																			<option value={item.name}  className="attached enabled" key={i}>{item.name}</option>
																		))
																	}
																</select>
															</td>
														</tr>
													}

													{
														pData.pData && pData.pData[0].sleeve_status === "True" &&
														<tr>
															<td className="label ">
																<label htmlFor="pa_color" className="col-md-3">Sleeve</label>
															</td>
															<td className="value">
																<select className="col-md-9 variationsSelect" name="attribute_pa_color" data-attribute_name="attribute_pa_color" data-show_option_none="yes" onChange={(e) => changeSleeve(e)} value={bgSleeve}>
																	{ 
																		pData.SleeveData.map((item,i)=>(
																			<option value={item.name}  className="attached enabled" key={i}>{item.name}</option>
																		))
																	}
																</select>
															</td>
														</tr>
													}	
												</tbody>
											</table>
										</Col>
									</div>

									<Nav variant="pills" className="flex-row">
										<Nav.Item>
											{/* <Nav.Link eventKey="first" className="btn btn-primary bg-bd-color">
												Color
											</Nav.Link> */}
										</Nav.Item>
										<Nav.Item>
											<Nav.Link eventKey="first" className="btn btn-primary bg-bd-color">
												Image
											</Nav.Link>
										</Nav.Item>
										<Nav.Item>
											<Nav.Link eventKey="second" className="btn btn-primary bg-bd-color">
												Text
											</Nav.Link>
										</Nav.Item>
										
									</Nav>
									<Tab.Content>
										{/* <Tab.Pane eventKey="first">
											
										</Tab.Pane> */}
										<Tab.Pane eventKey="second">
											{bgImage === pData.pData[0].photo.back ?<div >
												<div className="col-md-12">
													<div className="row pt-2">
														<div className="col-md-3">
															<span className="p-field">
																<Form.Label>Add New Text</Form.Label>
															</span>
														</div>
														<div className="col-md-9 pl-0">
															<textarea className="form-control textAreaSize text-height-width" onChange={(e) => setTextDataB(e.target.value)} value={textDataB} placeholder="Type something here" rows="1" />
														</div>
													</div>
												</div>

												<div className="col-md-8">
													<div className="row">
														<div className="col-md-4">
															<span className="p-field">
																<label htmlFor="text">Text Align</label>
															</span>
														</div>
														<div className="col-md-4">
															<span className="btn-group">
																	<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignTextB('left')}><i className="fa fa-align-left"></i></Button>
																	<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignTextB('center')} ><i className="fa fa-align-center"></i></Button>
																	<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignTextB('right')} ><i className="fa fa-align-right"></i></Button>
																	<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignTextB('justify')} ><i className="fa fa-align-justify"></i></Button>
															</span>
														
														</div>
													</div>
												</div>
												<div className="col-md-8">
													<div className="row pt-2">
														{/* <Form.Group> */}
															<div className="col-md-4">
																<span className="p-field">
																	<Form.Label>Font Size</Form.Label>
																</span>
															</div>
															<div className="col-md-4">	
																<Form.Control type="range" className="rangeWdth" onChange={(e) => setFontSizeB(e.target.value)} value={fontSizeB} placeholder="" />
																</div>
														{/* </Form.Group> */}
													</div>
												</div>
												<div className="col-md-8">
													<div className="row pt-2">
														<div className="col-md-4">
															<span className="p-field">
																<Form.Label>Font Color</Form.Label>
															</span>
														</div>
														<div className="col-md-4">
															<Form.Control type="color" className="rangeWdth" onChange={(e) => setColorB(e.target.value)} value={colorB} placeholder="" />
														</div>
													</div>
												</div>

												<div className="col-md-8">
													<div className="row pt-2">
														<div className="col-md-4">
															<span className="p-field">
																<Form.Label>Font Family</Form.Label>
															</span>
														</div>
														<div className="col-md-4">
															<FontPicker
																apiKey="AIzaSyA94amz2aeB9v66mvhYBEPVubflbyN6z-k"
																className="form-control"
																activeFontFamily={fontFamilyB}
																onChange={(nextFont) =>
																	setFontFamilyB(nextFont.family)
																}
															/>
														</div>
													</div>
												</div>
											</div>:
											<div>
												{/* <Form.Group>
													<Form.Label>Add New Text</Form.Label>
													<textarea className="form-control textAreaSize text-height-width" onChange={(e) => setTextData(e.target.value)} value={textData} placeholder="Type something here"  rows="1" ></textarea> 
												</Form.Group> */}

												<div className="col-md-12">
													<div className="row pt-2">
														<div className="col-md-3">
															<span className="p-field">
																<Form.Label>Add New Text</Form.Label>
															</span>
														</div>
														<div className="col-md-9 pl-0">
															<textarea className="form-control textAreaSize text-height-width" onChange={(e) => setTextData(e.target.value)} value={textData} placeholder="Type something here"  rows="1" ></textarea>
														</div>
													</div>
												</div>


												{/* <span className="p-field">
													<label htmlFor="text">Text Align</label>
													<span className="btn-group ml-5">
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('left')}><i className="fa fa-align-left"></i></Button>
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('center')} ><i className="fa fa-align-center"></i></Button>
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('right')} ><i className="fa fa-align-right"></i></Button>
															<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('justify')} ><i className="fa fa-align-justify"></i></Button>
													</span>
												</span> */}

												<div className="col-md-8">
													<div className="row">
														<div className="col-md-4">
															<span className="p-field">
																<label htmlFor="text">Text Align</label>
															</span>
														</div>
														<div className="col-md-4">
															<span className="btn-group">
																<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('left')}><i className="fa fa-align-left"></i></Button>
																<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('center')} ><i className="fa fa-align-center"></i></Button>
																<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('right')} ><i className="fa fa-align-right"></i></Button>
																<Button label=""  className="btn-sm bg-pd-text-align" onClick={() => alignText('justify')} ><i className="fa fa-align-justify"></i></Button>
															</span>
														
														</div>
													</div>
												</div>

												{/* <Form.Group>
													<Form.Label>Font Size</Form.Label>
													<Form.Control type="range" onChange={(e) => setFontSize(e.target.value)} value={fontSize} placeholder="" />
												</Form.Group>*/}

												<div className="col-md-8">
													<div className="row pt-2">
														{/* <Form.Group> */}
															<div className="col-md-4">
																<span className="p-field">
																	<Form.Label>Font Size</Form.Label>
																</span>
															</div>
															<div className="col-md-4">	
																<Form.Control type="range" className="rangeWdth" onChange={(e) => setFontSize(e.target.value)} value={fontSize} placeholder="" />
															</div>
														{/* </Form.Group> */}
													</div>
												</div>

												{/* <Form.Group>
													<Form.Label>Font Color</Form.Label>
													<Form.Control type="color" onChange={(e) => setColor(e.target.value)} value={color} placeholder="" />
												</Form.Group> */}

												<div className="col-md-8">
													<div className="row pt-2">
														<div className="col-md-4">
															<span className="p-field">
																<Form.Label>Font Color</Form.Label>
															</span>
														</div>
														<div className="col-md-4">						
															<Form.Control type="color" className="rangeWdth" onChange={(e) => setColor(e.target.value)} value={color} placeholder="" />
														</div>
													</div>
												</div>

												{/* <Form.Group>
													<Form.Label>Font Family</Form.Label>
													<FontPicker
														apiKey="AIzaSyA94amz2aeB9v66mvhYBEPVubflbyN6z-k"
														className="form-control"
														activeFontFamily={fontFamily}
														onChange={(nextFont) =>
																setFontFamily(nextFont.family)
														}
												/>
												</Form.Group> */}

												<div className="col-md-8">
													<div className="row pt-2">
														<div className="col-md-4">
															<span className="p-field">
																<Form.Label>Font Family</Form.Label>
															</span>
														</div>
														<div className="col-md-4">
															<FontPicker
																apiKey="AIzaSyA94amz2aeB9v66mvhYBEPVubflbyN6z-k"
																className="form-control"
																activeFontFamily={fontFamily}
																onChange={(nextFont) =>
																	setFontFamily(nextFont.family)
																}
															/>
														</div>
													</div>
												</div>
											</div>
											}
										</Tab.Pane>
										<Tab.Pane eventKey="first">
											{bgImage === pData.pData[0].photo.back ?<Col>
													<h4 className="widget-title">
														UPLOAD ART
													</h4>
													<ImageUploader
															withIcon={true}
															buttonText='Choose images'
															onChange={(e) => pData.uploadImage(e, 'back')}
															// setSelectedImgB(URL.createObjectURL(e[0]))
															imgExtension={['.jpg', '.gif', '.png', '.gif','jpeg']}
															maxFileSize={5242880}
															singleImage={true}
													/>
													{
														pData.imageUrlDataB !== '' && 
														<div className="uploadImageRemove">
															<img src={pData.imageUrlDataB} alt="uploadImg" width="100px" />
															<span onClick={() => pData.remImg('back')} className="fa fa-trash removeImage"></span>
														</div>
													}
													
												</Col>:
												<Col>
													<h4 className="widget-title">
														UPLOAD ART
													</h4>
													<ImageUploader
														withIcon={true}
														buttonText='Choose images'
														onChange={(e) =>pData.uploadImage(e,'front') }
														// setSelectedImg(URL.createObjectURL(e[0]))
														imgExtension={['.jpg', '.gif', '.png', '.gif','jpeg']}
														maxFileSize={5242880}
														singleImage={true}
													/>
													{
														pData.imageUrlData !== '' && 
														<div className="uploadImageRemove">
															<img src={pData.imageUrlData} alt="uploadImg"  width="100px" />
															<span onClick={() => pData.remImg('front')} className="fa fa-trash removeImage"></span>
														</div>
													}
												</Col>
												}
										</Tab.Pane>
									</Tab.Content>

									{/* Product Option Select Start*/}

									<div className="product-action product-all-icons pt-4">
										<div className="product-single-qty qty-btn" style={{"display":"flex"}}>
												<button className="btn btn-outline" disabled={pData.qty === 1} onClick={()=> pData.setQty(pData.qty-1)}>-</button>
												<input className="horizontal-quantity form-control" type="text" value={pData.qty} placeholder='qty' readOnly/>												
												<button className="btn btn-outline" onClick={()=> pData.setQty(pData.qty < 20? pData.qty+1:pData.qty)}>+</button>
										</div>
										{/* End .product-single-qty */}
										<div className="paction add-cart show-color top-15 detais-btn pointer" title="Add to Cart" onClick={addToCard}>
											<span>Add to Cart</span>
										</div>
									</div>
							</div>
							{/* End .product-single-details */}
							
						</Col>
					</Row>
				</Tab.Container>
				</Col>
					</Row>
		</Container>
  );
}


export default  Tshirt